<template>
    <v-dialog v-model="isOpen" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">Registration Information</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div>
                    <p>
                        Please note that registration through the Telegram group is currently the only
                        method available.<br>
                        We plan to add new registration methods in the near future.
                    </p>

                   <p>To register for TinyGS, you need to first join our official Telegram group:</p>
                    <p>
                        <a href="https://t.me/joinchat/DmYSElZahiJGwHX6jCzB3Q "
                            target="_blank">https://t.me/joinchat/DmYSElZahiJGwHX6jCzB3Q </a>
                    </p>

                   <p>Then, open a private chat with <a href="https://t.me/tinygs_personal_bot" target="_blank" rel="noopener noreferrer">@tinygs_personal_bot</a> and use the following commands:</p>
                    <ul class="mb-3">
                       <li><code>/weblogin</code> - to access the web interface and register your email.</li>
                       <li><code>/mqtt</code> - to request your MQTT credentials.</li>
                    </ul>
                    <p>Follow the instructions provided by the bot to complete your registration.</p>

                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from 'vue'

export default {
  name: "TempRegisterDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.value,
      set: (val) => emit('input', val)
    })

    const closeDialog = () => {
      emit('input', false)
    }

    return {
      isOpen,
      closeDialog
    }
  }
}
</script>

<style scoped>
.v-card-title {
  align-items: center;
}
</style>